<template>
  <tile>
    <div class="header">
      <p class="title">Have More Docs?</p>
    </div>
    <div class="content" v-if="!error">
      <generic-uppy-uploader
        :name="'application'"
        :applicationId="application?.id"
        :applicant="applicant"
        :documentTypeId="docTypeId"
      />
    </div>
    <div v-else>
      <error />
    </div>
  </tile>
</template>
<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import { useStore } from "vuex";
import Tile from "@/components/shared/Tile.vue";
import Error from "@/components/shared/Error.vue";
import GenericUppyUploader from "@/components/shared/GenericUppyUploader.vue";

const props = defineProps({
  application: {
    type: Object,
    required: true,
  },
  applicant: {
    type: Object,
  },
  height: {
    type: Number,
  },
});

const store = useStore();
const error = ref<boolean>(false);
const docTypeId = computed<number>(() => store.state.lookupsModule.lookups?.documentTypes?.find((dt: any) => dt?.name?.trim() === 'Unknown')?.id || 1);
const referenceId = computed(() => props.application?.referenceId);
</script>
<style lang="scss" scoped>
.header {
  margin-bottom: 1rem;

  p {
    margin-bottom: 0;
  }

  .title {
    font-weight: 700;
    font-size: 1.25rem;
  }
}

.btn {
  background-color: var(--theme-color);
}

.download {
  cursor: pointer;

  /* unvisited link */
  a:link {
    color: red;
  }

  /* visited link */
  a:visited {
    color: green;
  }

  /* mouse over link */
  a:hover {
    color: var(--theme-color);
  }
}

.tile {
  // max-height: 350px;
}
</style>
